import { FileReference } from "Domain/Model/FileReference/FileReference";

export const FIND_FILE_REFERENCE_SUCCESS = 'FIND_FILE_REFERENCE_SUCCESS';

export const findFileReferenceSuccess = (fileReference: Record<string, FileReference>) => ({
    type: FIND_FILE_REFERENCE_SUCCESS,
    payload: { fileReference },
});
